<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6" class="py-4"> </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6" class="px-4 py-10 white">
        <v-container>
          <v-row justify="center">
            <v-col cols="12"
              ><div class="text-h5 font-weight-black my-2">
                {{ componentData.title }}
              </div>
            </v-col>

            <v-col cols="12" class="py-3" align="center">
              <div>
                <v-img :src="img" width="130" height="130"></v-img>
              </div>
            </v-col>
            <v-col>
              <div class="py-1"></div>
              <v-btn block large color="primary" @click="StartUsing()">
                <span class="mx-2 text-capitalize">{{
                  componentData.startUsing
                }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Google_GetSiteToken } from "@/apis/api";
import axios from "axios";

export default {
  name: "VerifyEmailExpired",
  data() {
    return {
      componentData: {
        title: "登入成功",
        startUsing: "開始使用",
      },
      iconSettinn: {
        name: "mdi-close-circle-outline",
        color: "warning",
        size: "50",
      },
      img: require("@/assets/image/components/bigCheck.svg"),
    };
  },
  mounted() {
    this.componentData.startUsing = `前往${this.$store.state.fromSite.name}`;

    var guid = this.$route.query.guid;
    // Google登入轉址回來要從快取拿token需要的Guid存sessionStorage
    if (guid !== undefined) {
      // Guid塞進sessionStorage
      sessionStorage.setItem("_guid", guid);
      // 用Guid拿暫存在快取的token
      this.GetSiteToken(guid);
    }
  },
  methods: {
    // 用guid換token
    GetSiteToken(letter) {
      Google_GetSiteToken(letter)
        .then((res) => {
          localStorage.setItem("_token", res.data.token);
          this.GetEmailEncrypt(res.data.token);
          this.$emit("token", res.data.token);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 取得加密email
    GetEmailEncrypt(token) {
      const apiBaseUrl = process.env.VUE_APP_MAIN_API_BASE_URL;
      const header = {
        Authorization: "Bearer " + token,
      };
      const myRequest = axios.create({
        baseURL: apiBaseUrl,
        headers: header,
      });
      myRequest
        .get(`Token/emailEncrypt`)
        .then((res) => {
          this.emailEncrypt = res.data;
          localStorage.setItem("_emailEncrypt", res.data);
          this.GoFromSite(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    StartUsing() {
      this.GoFromSite(
        this.emailEncrypt
          ? this.emailEncrypt
          : localStorage.getItem("_emailEncrypt")
      );
    },
    // 從哪來回哪去
    GoFromSite(emailEncrypt) {
      if (localStorage.getItem("inviterQuery")) {
        // 用google登入的話會先存在localStorage 再從localStorage取 直接轉回去表單
        window.location.href =
          this.$store.state.fromSite.url +
          "/writeInvitedForm?emailEncrypt=" +
          emailEncrypt +
          "&" +
          localStorage.getItem("inviterQuery");
      } else {
        let fromCmid = localStorage.getItem("fromCmid");
        if (fromCmid) {
          localStorage.removeItem("fromCmid");
          window.location.href = `${this.$store.state.fromSite.url}/writeInvitedForm?cmid=${fromCmid}&uem=${emailEncrypt}`;
        } else {
          let fromSite = localStorage.getItem("fromSite");
          let url = "";
          if (fromSite.toLowerCase() === "sms") {
            url = process.env.VUE_APP_MAIN_SMS_BASE_URL;
          }
          if (fromSite.toLowerCase() === "lt") {
            url = "https://www.king-fong.com/";
          }
          if (fromSite.toLowerCase() === "wt") {
            url = process.env.VUE_APP_MAIN_WT_BASE_URL;
          }
          window.location.href = url + "?emailEncrypt=" + emailEncrypt;
        }
      }
    },
  },
};
</script>
